import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import "./scss/inventory.scss";
import { INVENTORY } from "../../constants/route-paths";
import { getTransactionsList } from "../../actions/inventory.action";
import { format } from "date-fns";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import CustomTable from '../../components/table/table';
import Cookies from "js-cookie";
import { useNavigate } from "react-router";

const Transactions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [transactions, setTransactions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [limit, setLimit] = useState(25);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const ignoreNextPageChange = useRef(false);

  const getTransactions = useCallback((currentLimit, currentOffset, currentSearch) => {
    const params = {
      limit: currentLimit,
      offset: currentOffset,
      search: currentSearch
    };

    setIsLoading(true);

    dispatch(getTransactionsList(params)).then((response) => {
      const transactionsList = response.transactions || [];
      const totalCount = response.totalCount || 0;
      const newTransactions = [];
      transactionsList.forEach((transaction, index) => {
        const itemName = transaction.items && transaction.items.item;
        newTransactions.push({
          sno: currentOffset + index + 1,
          itemName,
          ...transaction,
          createdAtTime: format(new Date(transaction.createdAt), "hh:mm a"),
          createdAt: format(new Date(transaction.createdAt), "dd/MM/yyyy"),
        });
      });

      setTransactions(newTransactions);
      setTotalCount(totalCount);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  useEffect(() => {
    const recordsPerPage = Cookies.get("recordsPerPage")
      ? parseInt(Cookies.get("recordsPerPage"))
      : 25;

    setLimit(recordsPerPage);

    const newColumns = [
      { title: "S No", field: "sno" },
      {
        title: "PO No.",
        field: "poId",
        render: (rowData) => {
          if (rowData.poId === "NO_PO" || rowData.poId === "No_PO") return "NO PO";
          if (rowData.poId === "INTERNAL STOCK" || rowData.poId === "DE_STOCK") return "INTERNAL STOCK";
          // Display PO Number from PurchaseOrder relation if available
          if (rowData.purchaseOrder) {
            return rowData.purchaseOrder.f_id || rowData.purchaseOrder.id || rowData.poId;
          }
          return rowData.poId;
        },
      },
      { title: "Transaction Type", field: "transactionType" },
      { title: "Transaction Location", field: "location" },
      { title: "Item Name", field: "itemName" },
      { title: "Quantity", field: "quantity" },
      { title: "Allocated To", field: "allocateToName" },
      { title: "Time", field: "createdAtTime" },
      { title: "Date", field: "createdAt" },
    ];
    setColumns(newColumns);

    // Initial fetch
    getTransactions(recordsPerPage, 0, "");
  }, [getTransactions]);

  const handlePageChange = (page, newLimit) => {
    if (ignoreNextPageChange.current) {
      ignoreNextPageChange.current = false;
      return;
    }
    const newOffset = (page - 1) * newLimit;

    setCurrentPage(page);

    setLimit(newLimit);

    getTransactions(newLimit, newOffset, search);
  };

  const handleLimitChange = (newLimit) => {
    ignoreNextPageChange.current = true;

    setLimit(newLimit);

    setCurrentPage(1);

    getTransactions(newLimit, 0, search);
  };

  const searchHandler = (value) => {
    setSearch(value);

    setCurrentPage(1);

    getTransactions(limit, 0, value);
  };

  const cancelHandler = () => {
    navigate(`/${INVENTORY}`);
  };

  return (
    <div className="purchase-order-block">

      <h2 className="content-heading text-uppercase">Inventory Transactions</h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler}>INVENTORY</Breadcrumb.Item>
          <Breadcrumb.Item active>Inventory Transactions</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <CustomTable
        columns={columns}
        data={transactions}
        fileName="Inventory Transactions List"
        itemsPerPage={limit}
        limit={limit}
        currentPage={currentPage}
        paginationCount={totalCount}
        pageHandler={handlePageChange}
        limitChangeHandler={handleLimitChange}
        isLoading={isLoading}
        searchHandler={searchHandler}
        externalSearchValue={search}
      />
    </div>
  );
};

export default Transactions;
